module.exports = __webpack_public_path__ + "static/dashboard-0a948baab1127a59e6821c2795ce57eb.mp4";